import type { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { isValidAmount } from 'src/shared/validatorUtils';

export const dormitoryAcademicFeeRule = (): Rule => {
  const { t } = useTranslation();

  return ({
    message: t('Please enter correct dormitory academic fee'),
    required: true,
    validator: async (_, value: string) => {
      if (Number(value) < 0) {
        throw new Error();
      }
      if (Number(value) > 1000) {
        throw new Error();
      }
      if (!isValidAmount(Number(value))) {
        throw new Error();
      }
    },
  });
};
